import { BlockItem } from '@/models/Blocks/Itens/block-item';
import { BlockProductPromo, BlockProductPrice } from '@/models/Blocks/Itens/block-product';
import { BlockMedia } from '@/models/Blocks/Itens/block-item-media';
import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';

export class BlockBundleProduct extends BlockMedia{
    protected _groupId?: string;
    protected _name: string;

    public constructor(name: string, groupId: string|undefined = undefined) {
        super();
        this._name = name;
        this._groupId = groupId;
    }

    public get name():string{
        return this._name;
    }

    public get groupId():string|undefined{
        return this._groupId;
    }
}

export class BlockBundle extends BlockItem {
    protected _firstProduct: BlockBundleProduct;
    protected _secondProduct: BlockBundleProduct;
    protected _promo?: BlockProductPromo;
    protected _price: BlockProductPrice;
    protected _id: string;
    protected _coupon: string;
    protected _promoRef?: object;
    protected _cssClass?: string;
    protected _overrideClick?: boolean;
    protected _urlDetail?: string;
    protected _transparentMode?: boolean;

    public constructor(id: string, coupon: string, first: BlockBundleProduct, second: BlockBundleProduct, price: BlockProductPrice, promo: BlockProductPromo|undefined = undefined){
        super(BlockItemType.bundle);
        this._firstProduct = first;
        this._secondProduct = second;
        this._promo = promo;
        this._price = price;
        this._id = id;
        this._coupon = coupon;
    }

    public get firstProduct():BlockBundleProduct{
        return this._firstProduct;
    }

    public get secondProduct():BlockBundleProduct{
        return this._secondProduct;
    }

    public get promo():BlockProductPromo|undefined{
        return this._promo;
    }

    public get price():BlockProductPrice{
        return this._price;
    }

    public get id():string{
        return this._id;
    }

    public get coupon():string{
        return this._coupon;
    }

    public get promoReference():object|undefined{
        return this._promoRef;
    }
    
    public get transparentMode():boolean|undefined{
        return this._transparentMode;
    }

    public set transparentMode(value: boolean|undefined){
        this._transparentMode = value;
    }

    public set promoReference(value: object|undefined){
        this._promoRef = value;
    }

    public get cssClass(): string|undefined {
        return this._cssClass;
    }

    public set cssClass(value: string|undefined) {
        this._cssClass = value;
    }

    public get overrideClick(): boolean {
        return this._overrideClick?? false;
    }

    public set overrideClick(value: boolean) {
        this._overrideClick = value;
    }

    public get urlDetail(): string|undefined {
        return this._urlDetail;
    }

    public set urlDetail(value: string|undefined) {
        this._urlDetail = value;
    }

    public get mubData():string|undefined{
        return !this.blockName ? this._mub : JSON.stringify({
            t: 'combo',
            b: this.blockName,
            m:{
                groupId: [this.firstProduct.groupId, this.secondProduct.groupId],
                comboId: this.id
            }
        });
    }
    
    public set mubData(value: string|undefined){
        this._mub = value;
    }
}